import { AnalysisIssueBasketballGameTbd } from '@hefe/models';
import IssueEventBlockComponent from '../issue-event-block/issue-event-block.component';

interface IssueBasketballGameTbdBodyComponentProps {
  issue: AnalysisIssueBasketballGameTbd;
}

export default function IssueBasketballGameTbdBody(
  props: IssueBasketballGameTbdBodyComponentProps
) {
  const { issue } = props;
  return (
    <>
      <IssueEventBlockComponent event={issue.context.event} />
    </>
  );
}
